module.exports = __webpack_public_path__ + "img/educator-bg.e33745dd.jpg";